import ManagerEdit from './ManagerEdit';

export default ManagerEdit;
